"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogVariants = void 0;
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("./buttons/Button"));
var use_notification_1 = require("../../hooks/use-notification");
var Notification_1 = require("./Notification");
var api_1 = __importDefault(require("api"));
var use_stores_1 = require("../../hooks/use-stores");
var DialogVariants;
(function (DialogVariants) {
    DialogVariants["CONFIRMATION"] = "confirmation";
    DialogVariants["ALERT"] = "alert";
})(DialogVariants = exports.DialogVariants || (exports.DialogVariants = {}));
var Dialog = function (_a) {
    var variant = _a.variant, title = _a.title, description = _a.description, onSubmit = _a.onSubmit, open = _a.open, onClose = _a.onClose, withComment = _a.withComment, queryId = _a.queryId, stage = _a.stage, direction = _a.direction, dontSaveComment = _a.dontSaveComment;
    var _b = react_1.useState(""), comment = _b[0], setComment = _b[1];
    var notification = use_notification_1.useNotification();
    var queriesStore = use_stores_1.useStores().queriesStore;
    var changeHandler = function (e) {
        setComment(e.currentTarget.value);
    };
    var submitHandler = function (e) {
        if (!withComment) {
            onSubmit();
        }
        if (comment.length <= 0 && withComment) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Please enter a comment"
            });
            return;
        }
        if (!dontSaveComment) {
            api_1.default.postComment(queryId, comment, stage, direction)
                .then(function (response) {
                queriesStore.editDataItem(response.data);
                setComment("");
                onSubmit();
            }, function (error) {
                console.log(error);
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "There was an error when posting your comment"
                });
            })
                .catch(function (error) {
                console.log(error);
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "There was an error when posting your comment"
                });
            });
        }
    };
    return (react_1.default.createElement("div", { className: "dialog", "data-open": open, "data-close": "true" },
        react_1.default.createElement("div", { className: "dialog__content" },
            react_1.default.createElement("div", { className: "dialog__title" }, title),
            react_1.default.createElement("div", { className: "dialog__description" },
                react_1.default.createElement("p", null, description)),
            withComment &&
                react_1.default.createElement("div", { className: "dialog__comment" },
                    react_1.default.createElement("textarea", { name: "comment", value: comment, placeholder: "Write a comment...", onChange: changeHandler })),
            react_1.default.createElement("div", { className: "actions" },
                react_1.default.createElement("div", { className: "flex flex-row flex-center" },
                    react_1.default.createElement("div", { className: "actions__buttons flex flex-row flex-center" },
                        variant !== DialogVariants.ALERT &&
                            react_1.default.createElement(Button_1.default, { onClick: onClose }, withComment && "Cancel" || "No"),
                        react_1.default.createElement(Button_1.default, { onClick: submitHandler }, variant === DialogVariants.ALERT && "OK" || withComment && "Confirm" || "Yes")))))));
};
exports.default = Dialog;
